export default "__VITE_ASSET__C$HGx1rg__"